module.exports = __webpack_public_path__ + "img/vertical_7_2_8011.3dc94ed8.png";